import type { FeatureEnum } from '../CRMEnums';
import type { DefinedPropertyFilters } from './filterDefinitions';

export const ORDER_BY = {
	ASC: 'asc',
	DESC: 'desc'
} as const;

export type OrderBy = (typeof ORDER_BY)[keyof typeof ORDER_BY];

/** Ordenação suportada pela API de Shorts (featured-videos). */
export const SHORTS_SORT_BY = {
	ASKING_PRICE: 'asking_price',
	SUCCESS_PROBABILITY: 'success_probability',
	PRIORITY: 'priority',
	RELEVANCE: 'relevance'
} as const;

export type ShortsSortBy = (typeof SHORTS_SORT_BY)[keyof typeof SHORTS_SORT_BY];

export type FeaturedVideosRecommendationStrategy = 'similar';
export type FeaturedVideosRecommendationType =
	| 'legacy'
	| 'similares'
	| 'fallback';

export type SortBy = NonNullable<DefinedPropertyFilters['sortBy']>;
export type PaginatedPropertyFilters = DefinedPropertyFilters & {
	page: number;
	perPage: number;
};
export type PropertyFilters = DefinedPropertyFilters;

export interface ShortsFilters {
	excludeProperties?: string[];
	/** Public slug of the responsible agent. */
	agentSlug?: string;
	page?: number;
	perPage?: number;
	orderBy?: OrderBy;
	sortBy?: ShortsSortBy;
	cities?: string[];
	states?: string[];
	macroregions?: string[];
	regions?: string[];
	propertyTypes?: string[];
	minAskingPrice?: number;
	maxAskingPrice?: number;
	minArea?: number;
	maxArea?: number;
	bedrooms?: number;
	suites?: number;
	parkingSpots?: number;
	displayInHomeShorts?: boolean;
	referenceProperty?: string;
	/** Grupos de property_type presentes no filtro (ex.: ['house', 'apartment']), resolvidos via getPropertyTypeGroup. */
	propertyTypeGroup?: string[];
	/** Raio (km) usado pelo back para variar a região por macroregion quando a busca é expandida. */
	radius?: number;
	poiLocationLat?: number;
	poiLocationLng?: number;
	onlyUnwatched?: boolean;
	/**
	 * Parâmetro da API `featured-videos`: incluir imóvel só com imagem a cada N resultados.
	 */
	includeImagesEvery?: number;
}

/** Valor usado nas rotas `/shorts` (listagem e reel) ao chamar featured-videos. */
export const SHORTS_FEATURED_VIDEOS_INCLUDE_IMAGES_EVERY = 6;
